export default __webpack_public_path__ + "static/media/radiology.b3929b6e.svg";